import type { SVGProps } from "react";

export const Wrike = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 90 90" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>Wrike</title>
    <path
      d="M21.111 37.211c4.357 0 6.41.818 9.564 4.048l16.93 17.319c.502.513.603.716.7 1.023.051.104.051.256.051.36 0 .102 0 .254-.05.358-.098.308-.2.513-.701 1.024L36.036 73.23c-.502.513-.7.614-1 .718-.102.051-.253.051-.354.051-.098 0-.25 0-.348-.05-.303-.105-.505-.206-1.004-.72L.525 39.673c-.953-.975-.603-2.46 1.001-2.46h19.585Zm47.78-21.16c-4.357 0-6.41.817-9.566 4.047l-16.93 17.32c-.499.512-.6.715-.7 1.022-.051.104-.051.257-.051.36 0 .102 0 .255.05.359.101.307.202.513.701 1.023l11.572 11.837c.499.513.7.615 1 .716.102 0 .253 0 .351-.05.3-.102.502-.204 1.001-.716l33.156-33.511c.953-.973.602-2.458-.999-2.458H68.892v.05Z"
      fill="#00D456"
      fillRule="evenodd"
    />
  </svg>
);

export default Wrike;
